import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Cabinet } from '../../core/models/cabinet.model';
import * as CabinetActions from './cabinet.actions';

export const cabinetsFeatureKey = 'cabinets';

export interface CabinetState extends EntityState<Cabinet> {
  // additional entities state properties
}

export const adapter: EntityAdapter<Cabinet> = createEntityAdapter<Cabinet>();

export const initialState: CabinetState = adapter.getInitialState({
  // additional entity state properties
});


export const reducer = createReducer(
  initialState,
  on(CabinetActions.addCabinet,
    (state, action) => adapter.addOne(action.cabinet, state)
  ),
  on(CabinetActions.upsertCabinet,
    (state, action) => adapter.upsertOne(action.cabinet, state)
  ),
  on(CabinetActions.addCabinets,
    (state, action) => adapter.addMany(action.cabinets, state)
  ),
  on(CabinetActions.upsertCabinets,
    (state, action) => adapter.upsertMany(action.cabinets, state)
  ),
  on(CabinetActions.updateCabinet,
    (state, action) => adapter.updateOne(action.cabinet, state)
  ),
  on(CabinetActions.updateCabinets,
    (state, action) => adapter.updateMany(action.cabinets, state)
  ),
  on(CabinetActions.deleteCabinet,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CabinetActions.deleteCabinets,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CabinetActions.loadCabinets,
    (state, action) => adapter.setAll(action.cabinets, state)
  ),
  on(CabinetActions.clearCabinets,
    state => adapter.removeAll(state)
  ),
);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
